exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ModellingError .v--modal-box.v--modal{min-height:410px!important;min-width:460px!important}#ModellingError .modal__content{overflow-y:hidden!important}#ModellingError .modal__footer{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ea4c6d9","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/ModellingError.vue
// module id = 1844
// module chunks = 0